var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDanger = function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.954.86a1.2 1.2 0 0 1 2.092 0L9.394 6.81A1.2 1.2 0 0 1 8.349 8.6H1.652A1.2 1.2 0 0 1 .606 6.811L3.954.86ZM5.6 6.8a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0ZM5 2a.6.6 0 0 0-.6.6v1.8a.6.6 0 1 0 1.2 0V2.6A.6.6 0 0 0 5 2Z",
    fill: "#F95A59"
  })));
};
export default SvgDanger;